import { render, staticRenderFns } from "./classParam.vue?vue&type=template&id=bc3993ba"
import script from "./classParam.vue?vue&type=script&lang=js"
export * from "./classParam.vue?vue&type=script&lang=js"
import style0 from "./classParam.vue?vue&type=style&index=0&id=bc3993ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports